import React, { Component } from 'react'
import getChartData from '../../constants/chartData'
import Chart from './Chart'

export const title = '柱状图'

export const description = '切换显示年份与销量的关系'

export class Demo extends Component {
  state = {
    option: 1,
  }

  render() {
    const { option } = this.state
    const chartData = getChartData(option)
    return (
      <>
        <select
          data-testid="switchData"
          onChange={this.switchData}
          value={option}
        >
          <option value={1}>数据集1</option>
          <option value={2}>数据集2</option>
          <option value={3}>数据集3</option>
        </select>
        <Chart
          data={chartData.array}
          xAxis={chartData.xAxis}
          yAxis={chartData.yAxis}
        />
      </>
    )
  }

  switchData = e => {
    this.setState({ option: e.target.value })
  }
}

export const example = `class Demo extends Component {
  state = {
    option: 1,
  }

  render() {
    const { option } = this.state
    const chartData = getChartData(option)
    return (
      <>
        切换
        <select
          data-testid="switchData"
          onChange={this.switchData}
          value={option}
        >
          <option value={1}>数据集1</option>
          <option value={2}>数据集2</option>
          <option value={3}>数据集3</option>
        </select>
        <Chart
          data={chartData.array}
          xAxis={chartData.xAxis}
          yAxis={chartData.yAxis}
        />
      </>
    )
  }

  switchData = e => {
    this.setState({ option: e.target.value })
  }
}
`
